module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/scandal.13d8736.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/scandal.jpg
// module id = /93n
// module chunks = 0